
/**
 * To match sitevision market structure
 */
export const convertToLocale = (custMarket) => {
    let market;
    switch (custMarket) {
        case "se":
            market = "sv-SE"
            break;
        case "no":
            market = "no-NO";
            break;
        case "dk":
            market = "da-DK";
            break;
        case "de":
            market = "de-DE";
            break;
        case "fi":
            market = "fi-FI";
            break;
        case "899310003":
            market = "sv-NewConstruction"
            break
        default:
            market = undefined;
    }
    return market;
}

export const convertMarketToCurrency = (custMarket) => {
    let market;
    switch (custMarket) {
        case "se":
            market = "SEK"
            break;
        case "no":
            market = "NOK";
            break;
        case "dk":
            market = "DKK";
            break;
        case "de":
            market = "EUR";
            break;
        case "fi":
            market = "EUR";
            break;
        default:
            market = undefined;
    }
    return market;
}

// Convert for XA & readablility
export const convertToCountry = (custMarket) => {
    let market = custMarket.toLowerCase().trim(),
        country;
    switch (market) {
        case "se":
            country = "Sverige";
            break;
        case "no":
            country = "Norge";
            break;
        case "dk":
            country = "Danmark";
            break;
        case "de":
            country = "Deutschland";
            break;
        case "fi":
            country = "Suomi";
            break;
        default:
            country = "";
    }
    return country;
}